'use strict';

/**
 * Map Stamp commercial-terms refusals to plain operator text.
 * Prefer the server's own wording unless the refusal is confidently about
 * missing review attestation fields — never rewrite on bare "confirm".
 */
function mapStampCommercialTermsError(raw) {
    const text = String(raw || '').trim()
        || 'Stamp commercial terms was refused.';
    if (/quoted terms changed/i.test(text)) {
        return 'The quoted terms changed while you were reviewing them. Refresh and check them again.';
    }
    if (/early system record|early policy reconciliation required/i.test(text)) {
        return 'This policy has an early system record that does not match the accepted quote. '
            + 'An authorised operator must replace that record before you continue.';
    }
    if (/permission|authoris|authoriz/i.test(text)) {
        return 'You do not have permission to confirm these quoted terms. Ask an authorised underwriter to review them.';
    }
    // Attestation-shaped only — not bare "confirm"/"reason"/"approval" tokens
    // (those collide with confirmedBoundPremiumCents and other status refusals).
    if (
        /requires reason code|short explanation|explanation must be at most|must not include internal stamp evidence markers/i
            .test(text)
    ) {
        return 'Add the reason and a short explanation before continuing.';
    }
    if (
        /unable to create stamp evidence note|stamp evidence note could not|more than one matching stamp evidence note|too many zoho notes|zoho writer is required|zoho note reader is required|zoho accepted the stamp evidence note/i
            .test(text)
    ) {
        return 'Could not save the stamp evidence note. Refresh and try again, or ask an operator for help.';
    }
    if (
        /zoho notes evidence|approval evidence note|stamp-quote-attestation|approval evidence reference/i
            .test(text)
    ) {
        return 'Stamp evidence could not be verified. Refresh and try again, or ask an operator for help.';
    }
    return text;
}

module.exports = {
    mapStampCommercialTermsError
};
